const app = {
  name: 'PORTAL SEKAR',
  desc: 'Portal Aduan Serikat Karyawan Hutama Karya',
  fullname: 'Serikat Karyawan',
  company: 'PT Hutama Karya (Persero)',
  guide: null,
  site: null,
  code: 'sekar-wbs-hk',
  logo: {
    sm: './static/img/logo/240x240.png',
    md: './static/img/logo/480x480.png',
    lg: './static/img/logo/720x720.png',
    global: './static/img/logo/logo-sekar.png'
  },
  server: {
    stagging: '/api/',
    development: 'https://sekar-aduan-hk.berinovasi.top/api/',
    production: '/api/',
    demo: 'https://sekar-aduan-hk.berinovasi.top/api/'
  },
  sso: {
    stagging: 'https://sekar-wbs.berinovasi.top/api/',
    development: 'https://sekar-wbs.berinovasi.top/api/',
    production: '?????',
    demo: 'https://sekar-wbs.berinovasi.top/api/'
  },
  download: {
    android: 'https://play.google.com/store/',
    ios: 'https://www.apple.com/id/app-store/'
  },
  options: {
    allowRegister: false,
    forgetPassword: false,
    autofill: false,
    myAction: false,
    asideRight: false,
    sso: false
  }
}

// =========================================================
// File CUSTOM Variable SCSS
// static\assets\sass\components\_variables.demo.scss
// =========================================================

export default app



// WEBPACK FOOTER //
// ./src/config.js